<template>
  <main-template hide-franquia>
    <v-row class="mx-3">
      <v-col cols="12">
        <v-btn text small @click="$router.back()">
          <v-icon left>mdi-arrow-left</v-icon>
          Voltar
        </v-btn>
        <h2 class="mt-2">Presenças Notifiq</h2>
      </v-col>

      <v-col cols="12" sm="5">
        <v-text-field
          v-model="filtroData"
          label="Filtrar por data"
          type="date"
          dense
          outlined
          clearable
          @change="buscarPresencas"
        />
      </v-col>
      <v-col cols="12" sm="4">
        <v-select
          v-model="filtroEvento"
          :items="tiposEvento"
          item-text="text"
          item-value="value"
          label="Tipo de evento"
          dense
          outlined
          clearable
          @change="buscarPresencas"
        />
      </v-col>
      <v-col cols="12" sm="3" class="d-flex align-center">
        <v-btn color="primary" @click="buscarPresencas" block>
          <v-icon left>mdi-magnify</v-icon>
          Buscar
        </v-btn>
      </v-col>

      <v-col cols="6" sm="3">
        <v-card outlined>
          <v-card-text class="text-center">
            <div class="text-h5 green--text">{{ totalEntradas }}</div>
            <div class="caption">Entradas</div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6" sm="3">
        <v-card outlined>
          <v-card-text class="text-center">
            <div class="text-h5 orange--text">{{ totalSaidas }}</div>
            <div class="caption">Saídas</div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th>ID</th>
                <th>Data</th>
                <th>Hora</th>
                <th>Tipo</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="presencas.length === 0">
                <td colspan="4" class="text-center grey--text py-4">
                  Nenhuma presença encontrada.
                </td>
              </tr>
              <tr v-for="presenca in presencas" :key="presenca.id">
                <td>{{ presenca.id }}</td>
                <td>{{ formatarData(presenca.data_evento) }}</td>
                <td>{{ formatarHora(presenca.data_evento) }}</td>
                <td>
                  <v-chip
                    small
                    :color="presenca.evento === 0 ? 'green' : 'orange'"
                    text-color="white"
                  >
                    {{ presenca.evento === 0 ? "Entrada" : "Saída" }}
                  </v-chip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </main-template>
</template>

<script>
export default {
  props: {
    matricula_id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      presencas: [],
      filtroData: null,
      filtroEvento: null,
      tiposEvento: [
        { text: "Entrada", value: 0 },
        { text: "Saída", value: 1 },
      ],
    };
  },
  computed: {
    totalEntradas() {
      return this.presencas.filter((p) => p.evento === 0).length;
    },
    totalSaidas() {
      return this.presencas.filter((p) => p.evento === 1).length;
    },
  },
  mounted() {
    this.buscarPresencas();
  },
  methods: {
    async buscarPresencas() {
      this.$loaderService.open("Carregando presenças...");
      try {
        const params = { matricula_id: this.matricula_id };
        if (this.filtroData) params.data = this.filtroData;
        if (
          this.filtroEvento !== null &&
          this.filtroEvento !== undefined &&
          this.filtroEvento !== ""
        ) {
          params.evento = this.filtroEvento;
        }
        const response = await this.$services.presencasService.getPresencasHikvision(params);
        this.presencas = response.presencas || [];
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    formatarData(dataEvento) {
      return new Date(dataEvento).toLocaleDateString("pt-BR");
    },
    formatarHora(dataEvento) {
      return new Date(dataEvento).toLocaleTimeString("pt-BR");
    },
  },
};
</script>
